import { render, staticRenderFns } from "./d-book-vote-button.vue?vue&type=template&id=7f35dd88&scoped=true&"
import script from "./d-book-vote-button.vue?vue&type=script&lang=js&"
export * from "./d-book-vote-button.vue?vue&type=script&lang=js&"
import style0 from "./d-book-vote-button.vue?vue&type=style&index=0&id=7f35dd88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35dd88",
  null
  
)

export default component.exports